import { Card, Col, Row, Tabs, Tag, Typography } from "antd";
import IndexAttendancePolicyPlanner from "../../policyManagement/attendancePolicyPlanner/IndexAttendancePolicyPlanner";
import IndexRequestPolicyPlanner from "../../policyManagement/requestPolicyPlanner/IndexRequestPolicyPlanner";
import PayrollEmployeePolicyAssignment from "./PayrollEmployeePolicyAssignment";

const { Paragraph, Text } = Typography;

const PayrollPolicyCenter = (props) => {
  return (
    <div className="payroll-workspace__section">
      {/* <Row gutter={ [16, 16] }>
        <Col xs={ 24 } lg={ 8 }>
          <Card bordered={ false } className="payroll-workspace__detail-card">
            <Text type="secondary">Policy planners</Text>
            <Paragraph style={ { marginBottom: 0, marginTop: 8 } }>
              Create and maintain attendance and request policy planners from payroll without sending HR back to the navigation menu.
            </Paragraph>
          </Card>
        </Col>
        <Col xs={ 24 } lg={ 8 }>
          <Card bordered={ false } className="payroll-workspace__detail-card">
            <Text type="secondary">Apply to employees</Text>
            <Paragraph style={ { marginBottom: 0, marginTop: 8 } }>
              Select an employee, update payroll details, and assign the right policy from the same workspace.
            </Paragraph>
          </Card>
        </Col>
        <Col xs={ 24 } lg={ 8 }>
          <Card bordered={ false } className="payroll-workspace__detail-card">
            <Text type="secondary">Safe workflow</Text>
            <Paragraph style={ { marginBottom: 0, marginTop: 8 } }>
              This policy center reuses the existing modules under the hood, so the behavior stays familiar while the navigation friction goes away.
            </Paragraph>
          </Card>
        </Col>
      </Row> */}

      <Card bordered={ false } className="payroll-workspace__detail-card">
        <Tabs
          defaultActiveKey="attendance"
          items={ [
            {
              key: "attendance",
              label: <span>Attendance Planner <Tag color="green">Core</Tag></span>,
              children: <IndexAttendancePolicyPlanner embedded modkey={ props.modkey } />,
            },
            // {
            //   key: "request",
            //   label: <span>Request Planner <Tag color="gold">Requests</Tag></span>,
            //   children: <IndexRequestPolicyPlanner embedded modkey={ props.modkey } />,
            // },
            {
              key: "assignment",
              label: <span>Apply To Employee <Tag color="blue">HR</Tag></span>,
              children: <PayrollEmployeePolicyAssignment modkey={ props.modkey } />,
            },
          ] }
        />
      </Card>
    </div>
  );
};

export default PayrollPolicyCenter;
